export function toTitleCase(s: string) {
  return s.replace(/(^|\s)\S/g, function (t) {
    return t.toUpperCase()
  })
}

export function snakeKabobToTitleCase(snaked: string) {
  const toReplaceRegex = /[_-]/g
  return toTitleCase(snaked.replaceAll(toReplaceRegex, ' '))
}
